import { render, staticRenderFns } from "./VendorComponent.vue?vue&type=template&id=06974a19&scoped=true"
import script from "./VendorComponent.vue?vue&type=script&lang=js"
export * from "./VendorComponent.vue?vue&type=script&lang=js"
import style0 from "./VendorComponent.vue?vue&type=style&index=0&id=06974a19&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06974a19",
  null
  
)

export default component.exports